export default __webpack_public_path__ + "static/media/rough.d1e76a29.svg";